<template>
  <div class="ModForm container">
    <div
      v-if="!hasWebsite"
    >
      <no-existing-resource
        :show-content="phoneHelp"
      >
        <template v-slot:title>
          {{ $t('no_existing_resource.service.title') }}
        </template>
        <template v-slot:explanation>
          {{ $t('no_existing_resource.service.explanation') }}
        </template>
        <template v-slot:resolution>
          <p>{{ $t('no_existing_resource.service.resolution') }}</p>
          <p class="is-size-2 has-text-weight-bold">
            {{ phoneHelp }}
          </p>
        </template>
      </no-existing-resource>
    </div>
    <div
      v-else
      class="container is-fullhd"
    >
      <mod-form />
    </div>
  </div>
</template>

<script>
import ModForm from '@/components/PageModification/ModFormContainer'
import NoExistingResource from '@/components/Shared/NoExistingResource'
import { mapState, mapGetters } from 'vuex'

export default {

  name: 'ModFormPage',

  components: {
    ModForm,
    NoExistingResource
  },

  data () {
    return {
      accountDetails: {}
    }
  },

  computed: {
    ...mapGetters(['serviceEnabled']),
    hasWebsite () {
        if (this.serviceEnabled('website')) {
          return true
        }
        return false
    },
    phoneHelp () {
      if (this.$store.state.useLocalStyle) {
        return this.$t('phone_number.help')
      }
      return this.$store.getters.brandConfigValue('phone_number', 'help')
    }
  },
  methods: {
    addDomainToAccount () {
      console.log('Add logic to add a domain:')
    }
  }
}
</script>

<style lang="css" scoped>
.website-mod-page {
  perspective: 100;
}
.resolution {
  margin-bottom: 15px;
}

.modal-container {
  position: absolute;
  top: 0;
  left: 0;
  right:0;
  bottom:0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modform.fade-leave-to {
  animation: slideup 1s ease-out;
  position: absolute;
  top: 0;
  left: 0;
  right:0;
  bottom:0;
  display: flex;
}

.local-modal {
  padding-top: 30px;
  width: 300px;
  height: 150px;
  background-color: rgba(34, 127, 207, .3);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

</style>

<style>
  /* Mobile style to apply globally */
  @media screen and (max-width: 575px) {
    .app-body .main .container-fluid {
      padding: 0 3px !important;
    }

    .main .website-mod-page {
      margin: 5px auto;
    }
  }
  .main {
    position: relative;
  }
</style>
